import Cookies from "js-cookie";
import Store from "../../../store/store";
import {
  setCookiesAccepted,
  setBannerAppsAccepted
} from "../../../store/actions/intro";
import { setGeoCountryLocation } from "../../../store/actions/country";
import { setEnvToContent } from "../../../store/actions/content";
import { isCountryDetected } from "../../constants/geoBlocked";
import { setEnvContent } from "../../../store/utils/helpers";

import {
  removeUser,
  loadUserFromCookies,
  USER_NEWSLETTER
} from "../../../store/actions/auth";

const LOCATION_NO_DETECTED = "UNKNOWN";

/**
 * Seed the store with everything that comes from the request (country, auth,
 * cookie banners).
 *
 * IMPORTANT: on the server every request MUST pass its own store. The module
 * level store is a single instance shared by the whole node process, so
 * dispatching request data into it lets concurrent requests overwrite each
 * other while `frontloadServerRender` awaits the CMS — the viewer country and
 * the logged user of one visitor end up rendered into another visitor's HTML.
 *
 * @param {object|null} req - express request (SSR) or null (client)
 * @param {object} store - store to dispatch into; defaults to the shared one,
 *                         which is correct on the client (a single store per tab)
 */
export function dispatchCookiesToStore(req = null, store = Store) {
  store.dispatch(removeUser());
  if (req !== null) {
    // `content.env` is process wide, not per request, so it is also kept on the
    // shared store for the helpers that read it outside of a connected component.
    setEnvContent(process.env.NODE_ENV);
    store.dispatch(setEnvToContent(process.env.NODE_ENV));
    // SSR
    // Cookies accept
    const cloudfrontViewerCountry =
      req.headers["cloudfront-viewer-country"] || LOCATION_NO_DETECTED;
    store.dispatch(setGeoCountryLocation(cloudfrontViewerCountry));

    store.dispatch(setCookiesAccepted("isCookiesAccepted" in req.cookies));
    store.dispatch(
      setBannerAppsAccepted("isBannerAppsAccepted" in req.cookies)
    );
    store.dispatch(loadUserFromCookies(req));
  } else {
    if (process.env.NODE_ENV === "local") {
      setEnvContent(process.env.NODE_ENV);
    }
    // Client
    // Keep the country detected during SSR (cloudfront-viewer-country header,
    // hydrated from __RTVCPLAY_STATE__). Only fall back to UNKNOWN when no
    // valid country was detected — otherwise we'd clobber it and break the
    // content geo-blocking that reads state.country.country.
    const ssrCountry =
      (store.getState().country && store.getState().country.country) || null;
    if (!isCountryDetected(ssrCountry)) {
      store.dispatch(setGeoCountryLocation(LOCATION_NO_DETECTED));
    }

    const isCookiesAccepted = Cookies.get("isCookiesAccepted");
    const isBannerAppsAccepted = Cookies.get("isBannerAppsAccepted");
    store.dispatch(
      setCookiesAccepted(
        isCookiesAccepted !== undefined ? isCookiesAccepted : false
      )
    );
    store.dispatch(
      setBannerAppsAccepted(
        isBannerAppsAccepted !== undefined ? isBannerAppsAccepted : false
      )
    );
    store.dispatch(loadUserFromCookies());
  }
}

export const hasNewsletterCookie = title => {
  const userNewsletterCookie = Cookies.get(USER_NEWSLETTER);
  let users = [];
  if (userNewsletterCookie) {
    users = JSON.parse(userNewsletterCookie);
  }
  return users.some(e => e.title === title);
};
export const addNewsletterCookie = (title, email) => {
  const userNewsletterCookie = Cookies.get(USER_NEWSLETTER);
  let users = [];
  if (userNewsletterCookie) {
    users = JSON.parse(userNewsletterCookie);
  }
  const isUserExists = users.some(e => e.title === title && e.email === email);
  if (!isUserExists) {
    users.push({ title, email });
    Cookies.set(USER_NEWSLETTER, users);
  }
};
